<template>
    <vue-content-loading :height="5" :width="6" >
        <rect x="0" y="0" rx="0" ry="0" width="10" height="0.9" />
        <rect x="0" y="1" rx="0" ry="0" width="11" height="0.9" />
        <rect x="0" y="2" rx="0" ry="0" width="10" height="0.9" />
        <rect x="0" y="3" rx="0" ry="0" width="11" height="0.9" />
        <rect x="0" y="4" rx="0" ry="0" width="10" height="0.9" />
        <rect x="0" y="5" rx="0" ry="0" width="11" height="0.9" />
    </vue-content-loading>
</template>

<script>
    import VueContentLoading from 'vue-content-loading';
    export default {
        name: "spinner-acc",
        components: {
            VueContentLoading,
        },
    }
</script>

<style scoped>

</style>
